/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const useCenterStyles = makeThemedStyles("WhiteBgArea", (theme) => ({
  root: {
    backgroundColor: "white",
    padding: "10px 20px 0px 20px",
    minHeight: "100vh",
  },
}));
const WhiteBgArea = (
  props: React.PropsWithChildren<{
    gap?: string;
    width?: string;
  }>
) => {
  const styles = useCenterStyles();
  return (
    <div
      className={styles.root}
      style={{
        gap: props.gap,
        width: props.width,
      }}
    >
      {props.children}
    </div>
  );
};

export default WhiteBgArea;
